import { extensions } from '../extensions/Extensions';
import { ResizePlugin } from './ResizePlugin';
import { TickerPlugin } from './TickerPlugin';

extensions.add(ResizePlugin);
extensions.add(TickerPlugin);
